import React, { useState, useEffect, useContext } from 'react'
import { useMutation, gql } from '@apollo/client'
import {
  Input,
  Select,
  Steps,
  Row,
  Col,
  Divider,
  Typography,
  Form,
  message,
} from 'antd'
import EmailLogin from 'components/auth/EmailLogin'
import SocialLink from 'components/auth/SocialLink'
import steps from 'components/data/steps.json'
import Button from 'components/shared/button'
import authContext from 'contexts/authStatus'

const { Step } = Steps
const { Option } = Select
const { TextArea } = Input
const { Paragraph, Title } = Typography

const CREATE_FAQ = gql`
  mutation ($input: createArticleInput) {
    createArticle(input: $input) {
      article {
        slug
        user {
          username
        }
      }
    }
  }
`

export default function AskQuery(props) {
  const { categories } = props
  const divStyle = { marginTop: '32px' }
  const [current, setCurrent] = useState(steps['Ask Query'])
  const [currentUserToken, setCurrentUserToken] = useState(null)
  // @ts-ignore
  const { setLogin } = useContext(authContext)
  const [form] = Form.useForm()

  useEffect(() => {
    if (localStorage.authToken) {
      setCurrentUserToken(localStorage.authToken)
    }
  }, [])

  const [AddFaq] = useMutation(CREATE_FAQ, {
    context: {
      headers: {
        Authorization: `Bearer ${currentUserToken}`,
      },
    },
  })

  const submitQuery = (values) => {
    AddFaq({
      variables: {
        input: {
          data: {
            slug: values.query,
            title: values.query,
            user: localStorage.userId,
            categories: values.categories,
            article_type: 'faq',
          },
        },
      },
    })
      .then(() => {
        message.info('Your question is succesfully Added')
        form.resetFields()
        setCurrent(steps.Done)
      })
      .catch((e) => {
        message.error(e.message)
      })
  }
  const handleAddQuery = (values) => {
    if (currentUserToken) {
      submitQuery(values)
    } else {
      localStorage.setItem('query', JSON.stringify(values))
      setCurrent(steps['Login/Register'])
    }
  }

  const sumbitContentCallback = async () => {
    const tempMessage = JSON.parse(localStorage.query)
    localStorage.removeItem('query')
    setLogin(true)
    if (tempMessage) {
      await setCurrentUserToken(localStorage.authToken)
      submitQuery(tempMessage)
      message.info('Successfully Logged In!')
    }
  }

  return (
    <Row
      className="page-wrapper page"
      style={{ justifyContent: 'center', display: 'flex' }}
    >
      <Col xs={24} lg={12}>
        <Steps progressDot current={current}>
          <Step
            title="Ask your Query"
            description="Please type your investment related query."
          />
          <Step
            title="Login/Register"
            description="please login/register to post your query"
          />
          <Step title="Done" />
        </Steps>
        {current === steps['Ask Query'] && (
          <div style={{ flexDirection: 'column', marginTop: '40px' }}>
            <Form form={form} name="basic" onFinish={handleAddQuery}>
              <Form.Item
                name="query"
                rules={[
                  { required: true, message: 'Please type your query...' },
                ]}
              >
                <TextArea
                  placeholder="Type your query here e.g What is cover order"
                  rows={1}
                />
              </Form.Item>
              <Form.Item name="categories">
                <Select
                  mode="multiple"
                  placeholder="Select Category"
                  style={{ width: 200 }}
                >
                  {categories.map((category) => (
                    <Option key={category.id} value={category.id}>
                      {category.attributes.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" source="submit-query">
                  Submit Query
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
        {current === steps['Login/Register'] && (
          <Row className="authPage">
            <Row>
              <Col span="24">
                <Row className="headerDescription">
                  <Col span="24">
                    <Title level={2}>Login to your Account.</Title>
                    <Paragraph>Please enter your details to login.</Paragraph>
                  </Col>
                </Row>
                <Row className="formContainer" style={divStyle}>
                  <Col span="24">
                    <Row className="row">
                      <Col span="24">
                        <SocialLink
                        // callbackbeforeRedirect={() => sumbitContentCallback()}
                        />
                        <Divider>or</Divider>
                        <EmailLogin
                          callbackbeforeRedirect={() => sumbitContentCallback()}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Row>
        )}
        {current === steps.Done && (
          <Row className="authPage">
            <Col>
              <div>
                Expert users on our site will still answering your question soon
              </div>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  )
}
